<template>
    <div>
      <v-card flat color="white" v-if="type=='create' || type=='edit' ">
        <v-toolbar color="primary" flat v-if="customer">
          <h3 class="title white--text">Quote: {{customer.name}} {{customer.surname}}</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="$emit('save', quote)">Save</v-btn>
          <v-btn @click="$emit('closeModal')" flat color="white">X</v-btn>
        </v-toolbar>
        <v-card-text>
            <v-layout justify-center align-center wrap>
                <v-flex xs3 mx-1>
                    <v-text-field label="Reference" v-model="quote.Reference"></v-text-field>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-menu >
                  <v-text-field
                    :value="quote.Date"
                    slot="activator"
                    label="Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker
                    v-model="quote.Date"
                  ></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-menu >
                  <v-text-field
                    :value="quote.ExpiryDate"
                    slot="activator"
                    label="Expires"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker
                    v-model="quote.ExpiryDate"
                  ></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex xs4 mx-1>
                    <h3 class="grey--text text-xs-center">Total:</h3>
                </v-flex>
                <v-flex xs4 mx-1>
                    <h3 class="grey--text text-xs-center">{{quote.Lines.reduce((a,b)=> +a+ +b.UnitPriceExclusive*b.Quantity*(1+(b.TaxType?b.TaxType.Percentage:0)), 0)|currency}}</h3>
                </v-flex>
                <v-flex xs10 mx-1>
                    <h3 class="grey--text text-xs-center">Line Items:</h3>
                </v-flex>
                <v-flex xs10 mx-1>
                    <v-card flat v-for="item in quote.Lines" :key="item">
                        <v-layout justify-left align-center wrap>
                            <v-flex xs3 mx-1>
                                <v-autocomplete :items="accounts" item-text="name" item-value="id" label="Account" v-model="item.SelectionId"></v-autocomplete>
                            </v-flex>
                            <v-flex xs2 mx-1>
                                <v-autocomplete :items="taxtypes" label="Tax Type" item-text="Name" item-value="ID" return-object v-model="item.TaxType"></v-autocomplete>
                            </v-flex>
                            <v-flex xs2 mx-1>
                                <v-text-field label="Quantity" v-model="item.Quantity" type="number"></v-text-field>
                            </v-flex>
                            <v-flex xs2 mx-1>
                                <v-text-field label="Unit Price Ex VAT" v-model="item.UnitPriceExclusive" type="number"></v-text-field>
                            </v-flex>
                            <v-flex xs2 mx-1>
                                <span class="grey--text">{{item.Quantity*item.UnitPriceExclusive | currency}}</span>
                            </v-flex>
                        </v-layout>
                        
                    </v-card>
                    <v-layout justify-center>
                            <v-btn flat color="primary" @click="quote.Lines?quote.Lines.push({SelectionId: null, LineType: 1, Quantity: 1, UnitPriceExclusive: 0}):quote.line=[{SelectionId: null, Quantity: 1, UnitPriceExclusive: 0}]"><v-icon>add_circle_outline</v-icon></v-btn>
                        </v-layout>
                </v-flex>
                
            </v-layout>
        </v-card-text>
      </v-card>

      <v-card flat color="white" v-else-if="type=='read'">
        <v-toolbar color="primary" flat v-if="quote">
          <h3 class="title white--text">{{quote.DocumentNumber}} | Total: {{quote.Total | currency}}</h3>
          
          <v-spacer></v-spacer>
          <v-btn @click="$emit('closeModal')" flat color="white">X</v-btn>
        </v-toolbar>
        <v-card-text>
            <v-layout justify-center align-center wrap>
                <v-flex xs3 mx-1>
                    <v-layout>
                        <b class="grey--text">Reference: </b>
                        <span class="grey--text ml-1"> {{quote.Reference}}</span>
                    </v-layout>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-layout>
                        <b class="grey--text">Date: </b>
                        <span class="grey--text ml-1"> {{formatDate(quote.Date)}}</span>
                    </v-layout>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-layout>
                        <b class="grey--text">Expiry Date: </b>
                        <span class="grey--text ml-1"> {{formatDate(quote.ExpiryDate)}}</span>
                    </v-layout>
                </v-flex>
                <v-flex xs10 mx-1>
                    <v-data-table
                    :items="quote.Lines"
                    :headers="quoteHeaders"
                    :rows-per-page-items="8"
                    >
                    \<template v-slot:items="props">
                  <td > {{props.item.Description}}</td>
                  <td > {{props.item.Quantity}}</td>
                  <td > {{taxtypes.find(x=>x.ID==props.item.TaxTypeId).Name}}</td>
                  <td > {{props.item.UnitPriceExclusive | currency}}</td>
                  <td > {{props.item.UnitPriceInclusive | currency}}</td>
                  <td > {{props.item.Total | currency}}</td>
                  </template>                    
                    </v-data-table>
                </v-flex>
                
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-center align-center wrap>
                <v-btn v-if="!loading" round color="primary" class="white--text" @click="$emit('acceptPay', quote), loading = true">Accept & Pay</v-btn>
                <v-btn v-else disabled round color="primary" class="white--text">Processing 
                  <v-progress-circular color="white" size="20" indeterminate></v-progress-circular>
                </v-btn>

            </v-layout>
        </v-card-actions>
      </v-card>
    </div>
</template>
<script>
import dateformat from "dateformat";
export default {
    props: ['accounts', 'customer', 'quote', 'quotemodal', 'taxtypes', 'type'],
    data(){
        return {
            item: {},
            loading: false,
            modal: false,
            quoteHeaders: [
                {
          text: "Description",
          align: "center",
          value: "Description"
        },
        {
          text: "Quantity",
          align: "center",
          value: "Quantity"
        },
        {
          text: "Tax",
          align: "center",
          value: "Quantity"
        },
        {
          text: "Unit Price Excl. VAT",
          align: "center",
          value: "UnitPriceExclusive"
        },
        {
          text: "Unit Price Incl. VAT",
          align: "center",
          value: "UnitPriceInclusive"
        }
        ,
        {
          text: "Total",
          align: "center",
          value: "Total"
        }
            ]
        }
    },
    created(){
        this.modal = true
    },
    methods: {
         formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    }
    
}
</script>